var _defs, _path, _polygon, _polygon2, _polygon3, _g, _g2, _g3, _polygon4, _path2, _polygon5, _path3, _polygon6, _path4, _polygon7, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect, _path10, _path11, _path12, _polygon8, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9b82cae-981b-4cb5-89fc-37ce88246016",
    "data-name": "DE Logo - SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303 212.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ee2a2752-f199-40bc-8c90-68ebe93cdb02{fill:none;}.a0f1ef83-0b88-46f1-88ea-db3403f4eb32{fill:#e7262b;}.bf7d868f-9178-43dc-8b6b-2c11361e6fba{fill:#ee4080;}.ac7093d6-f6f6-4fb7-a254-458f0156a3dc{fill:#fdb830;}.e1df3dcf-293b-4190-a957-5e4ec98540d1{fill:#f89521;}.e1ddee86-9970-49e2-bdb1-4dab13cee87f{clip-path:url(#b519d13d-4f52-4998-9ea5-a4ee81b1db66);}.ebfbd7d8-939a-434c-bcfe-5099535d944c{fill:url(#e51586d8-4605-4b9c-8bb3-9696a42b3fe3);}.b550dc9d-434d-47e8-b3cf-75e416d1dd72{clip-path:url(#aae8ef3c-5506-4b69-b794-4818dd5a51e5);}.afc8ec44-ce3c-4e5c-a1be-572fccd4c7a9{fill:url(#b5f79bb8-ab43-46b4-bde8-516efc27c998);}.bd0a5d6e-99fd-49c9-8cb1-204ae2943370{clip-path:url(#f94862a5-2514-42dc-93fa-2907e7a629b5);}.e77ae88d-4ad3-4ec6-9819-a1c5a340fa57{fill:url(#a730a196-c4e7-478a-8ca1-c27b4430d031);}.ff6c379d-1efd-46ac-94bb-462e4be529ad{fill:#211e1f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b519d13d-4f52-4998-9ea5-a4ee81b1db66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ee2a2752-f199-40bc-8c90-68ebe93cdb02",
    points: "266.2 63.6 303 84.8 303 42.4 266.2 63.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e51586d8-4605-4b9c-8bb3-9696a42b3fe3",
    x1: -266.21,
    y1: 389.68,
    x2: -263.38,
    y2: 389.68,
    gradientTransform: "matrix(12.97, 0, 0, -12.97, 3719.53, 5118.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292a66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46296d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5f2973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b64181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aae8ef3c-5506-4b69-b794-4818dd5a51e5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ee2a2752-f199-40bc-8c90-68ebe93cdb02",
    points: "266.2 63.6 303 42.4 266.2 21.2 266.2 63.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5f79bb8-ab43-46b4-bde8-516efc27c998",
    x1: -234.94,
    y1: 391.07,
    x2: -232.11,
    y2: 391.07,
    gradientTransform: "matrix(0, 14.98, 14.98, 0, -5574.5, 3541.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb5527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#eb5527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f17f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f39123"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f94862a5-2514-42dc-93fa-2907e7a629b5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ee2a2752-f199-40bc-8c90-68ebe93cdb02",
    points: "266.2 106.1 303 84.8 266.2 63.6 266.2 106.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a730a196-c4e7-478a-8ca1-c27b4430d031",
    x1: -266.21,
    y1: 388.62,
    x2: -263.38,
    y2: 388.62,
    gradientTransform: "matrix(12.97, 0, 0, -12.97, 3719.53, 5126.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae2a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ae2a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b4294c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cf2354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e01f59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61e5b"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DE Logo - SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a0f1ef83-0b88-46f1-88ea-db3403f4eb32",
    d: "M76,167.3V117c-1.4.3-7.2,2.1-10.4,5.4a6.4,6.4,0,0,0-2.1,4.3v40.6Zm46.2-44.1c-4.6-4.7-9.9-5.4-16.5-5.5s-13.3,2.8-14.5,3.7a3.8,3.8,0,0,0-1.7,3.1v6.6a51.9,51.9,0,0,1,14.1-2.5c3.7,0,6.8.5,8.9,2.1s2.6,5.2,2.6,6.8v1.1h-.2s-5.5-.6-11.3-.6-10.7,1-14.2,3.7A15.4,15.4,0,0,0,84,153.3a14.3,14.3,0,0,0,5.2,11.5c2.8,2.3,8.1,3.5,12.6,3.4a30.5,30.5,0,0,0,10.1-1.5,10.6,10.6,0,0,0,2.9-1.6l.3-.3v2.5h11.7V138.8c0-6.7-1.1-12.1-4.6-15.6m-7.1,27.6a8.4,8.4,0,0,1-4.9,7.8,15.2,15.2,0,0,1-5.7,1.3,10.8,10.8,0,0,1-5.3-1.4,6.2,6.2,0,0,1-2.7-5.4,7.2,7.2,0,0,1,.9-3.7c1.4-2.1,4.1-3.5,8.7-3.6h1.1a25.7,25.7,0,0,1,7.9,1Zm20.7-40.9a6.8,6.8,0,0,1,1.8-4.7c3.3-3.3,9.3-4.8,10.7-5.2v67.3H135.8Zm45.8,7.8c-14.8,0-26.3,11.2-26.3,25.6s11.3,25.1,26.1,25.1,26.7-11,26.7-25.5-11.6-25.2-26.5-25.2m0,39.9c-7.5,0-13.6-6.6-13.6-14.7s5.7-14.1,13.4-14.1,13.8,6.2,13.8,14.5-5.7,14.3-13.6,14.3m75.6-37.9a8.1,8.1,0,0,0-4.3,3.9c-5.4-5-11.8-5.7-17.1-5.7-11.2,0-22.1,8.2-22.1,23.4S224.8,164,235.8,164c6.3,0,12.1-1.5,17.2-5.9,0,6.2-1.7,9.4-3.5,11.3s-6.5,4-11.9,4a36,36,0,0,1-7.9-1.2v6a4,4,0,0,0,2.4,3.7c3.1,1.4,7.7,1.9,10.8,1.9a24.7,24.7,0,0,0,17-6.7c4.2-4.1,6.3-11.1,6.3-20.1V117.9a36.4,36.4,0,0,0-9,1.8m-17.4,33.6c-7.7,0-13.2-5.4-13.2-12.3s4.7-12.5,12.6-12.5,13.7,4.7,13.7,12.8-5.4,12-13.1,12m-216,14H2V123.6c0-1.4.1-3.5,1.5-4.9,3.6-3.7,9.1-4,11.1-4.3v41.2h9.2C35,155.6,43,146,43,134.3v-.2c0-11.7-7.6-19.7-19.2-19.7H14.2a16.1,16.1,0,0,1-11-4.1,8.4,8.4,0,0,1-2.6-5.8v-2H23.8c19.5,0,32.9,13.2,32.9,31.8v.2c0,18.6-13.4,32.8-32.9,32.8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "bf7d868f-9178-43dc-8b6b-2c11361e6fba",
    points: "229.5 84.8 266.2 106.1 266.2 63.6 229.5 84.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "ac7093d6-f6f6-4fb7-a254-458f0156a3dc",
    points: "229.5 0 229.5 42.4 266.2 21.2 229.5 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "e1df3dcf-293b-4190-a957-5e4ec98540d1",
    points: "266.2 21.2 266.2 21.2 229.5 42.4 266.2 63.6 266.2 21.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e1ddee86-9970-49e2-bdb1-4dab13cee87f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ebfbd7d8-939a-434c-bcfe-5099535d944c",
    x: 266.2,
    y: 42.4,
    width: 36.7,
    height: 42.43
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b550dc9d-434d-47e8-b3cf-75e416d1dd72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "afc8ec44-ce3c-4e5c-a1be-572fccd4c7a9",
    x: 266.2,
    y: 21.2,
    width: 36.7,
    height: 42.43
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "bd0a5d6e-99fd-49c9-8cb1-204ae2943370"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e77ae88d-4ad3-4ec6-9819-a1c5a340fa57",
    x: 266.2,
    y: 63.6,
    width: 36.7,
    height: 42.43
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    points: "20.9 211 1.7 211 1.7 192.7 20.2 192.7 20.2 195.4 4.7 195.4 4.7 200.1 15.5 200.1 15.5 202.9 4.7 202.9 4.7 208.3 20.9 208.3 20.9 211"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M21.7,211.8H.9V191.9H21v4.3H5.5v3.1H16.3v4.3H5.5v3.9H21.7ZM2.5,210.2H20.1v-1.1H3.9v-7H14.7v-1.2H3.9v-6.3H19.4v-1.2H2.5Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    points: "50.4 211 46.6 211 32.6 196 32.6 211 29.6 211 29.6 192.7 33.4 192.7 47.4 207.7 47.4 192.7 50.4 192.7 50.4 211"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M51.2,211.8H46.3L33.4,198v13.8H28.8V191.9h4.9l12.9,13.8V191.9h4.6ZM47,210.2h2.6V193.4H48.2v16.4L33,193.4H30.4v16.8h1.4V194Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    points: "79.7 195.4 70.9 195.4 70.9 211 67.9 211 67.9 195.4 59.1 195.4 59.1 192.7 79.7 192.7 79.7 195.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M71.7,211.8H67.1V196.2H58.3v-4.3H80.5v4.3H71.7Zm-3-1.6h1.4V194.6h8.8v-1.2h-19v1.2h8.8Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    points: "107.6 211 88.3 211 88.3 192.7 106.9 192.7 106.9 195.4 91.4 195.4 91.4 200.1 102.1 200.1 102.1 202.9 91.4 202.9 91.4 208.3 107.6 208.3 107.6 211"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M108.4,211.8H87.5V191.9h20.2v4.3H92.2v3.1h10.7v4.3H92.2v3.9h16.2Zm-19.3-1.6h17.7v-1.1H90.6v-7h10.7v-1.2H90.6v-6.3h15.5v-1.2h-17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M137.1,211h-3.6l-5-7h-9.2v7h-3.1V192.7h14.5a6.7,6.7,0,0,1,4.6,1.5,5.7,5.7,0,0,1,1.6,4.2,5.3,5.3,0,0,1-1.3,3.8,6.4,6.4,0,0,1-3.5,1.7Zm-6.8-9.7c2.3,0,3.5-1,3.5-2.8s-1.3-3.1-3.8-3.1H119.3v5.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M138.6,211.8h-5.5l-5-7H120v7h-4.6V191.9h15.3a7.3,7.3,0,0,1,5.1,1.7,6.3,6.3,0,0,1,1.9,4.8,5.7,5.7,0,0,1-1.6,4.3,6.2,6.2,0,0,1-2.7,1.7Zm-4.7-1.6h1.6l-4.7-6.9,1.2-.2a5.3,5.3,0,0,0,3-1.4,5,5,0,0,0,1.1-3.3,4.5,4.5,0,0,0-1.4-3.6,5.4,5.4,0,0,0-4-1.4H117v16.8h1.5v-7h10.4Zm-3.6-8.1H118.5v-7.5H130c4,0,4.6,2.4,4.6,3.9s-.6,3.6-4.3,3.6M120,200.5h10.3c2.4,0,2.7-1,2.7-2s-.4-2.3-3-2.3H120Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M160.3,192.7a6.2,6.2,0,0,1,4.4,1.5,5.7,5.7,0,0,1,1.7,4.2,5.4,5.4,0,0,1-1.7,4.2,8,8,0,0,1-5,1.4h-11v7h-3V192.7Zm-.6,8.6c2.4,0,3.6-1,3.6-2.8s-1.3-3.1-3.8-3.1H148.7v5.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M149.5,211.8h-4.6V191.9h15.4a7.4,7.4,0,0,1,5,1.7,6.6,6.6,0,0,1,1.9,4.8,6,6,0,0,1-2,4.8,8.2,8.2,0,0,1-5.5,1.6H149.5Zm-3-1.6h1.4v-7h11.8a7.1,7.1,0,0,0,4.5-1.2,4.6,4.6,0,0,0,1.4-3.6,4.9,4.9,0,0,0-1.4-3.6,5.5,5.5,0,0,0-3.9-1.4H146.5Zm13.2-8.1H147.9v-7.5h11.6c4,0,4.6,2.4,4.6,3.9s-.6,3.6-4.4,3.6m-10.2-1.6h10.2c2.4,0,2.8-1,2.8-2s-.4-2.3-3-2.3h-10Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M195.9,211h-3.6l-4.9-7h-9.3v7H175V192.7h14.5a6.5,6.5,0,0,1,4.6,1.5,5.7,5.7,0,0,1,1.6,4.2,5.3,5.3,0,0,1-1.3,3.8,6.5,6.5,0,0,1-3.4,1.7Zm-6.8-9.7c2.3,0,3.5-1,3.5-2.8s-1.3-3.1-3.8-3.1H178.1v5.9Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M197.4,211.8h-5.5l-5-7h-8v7h-4.7V191.9h15.3a7.3,7.3,0,0,1,5.1,1.7,6.2,6.2,0,0,1,1.9,4.8,6.1,6.1,0,0,1-1.5,4.3,6.9,6.9,0,0,1-2.7,1.7Zm-4.7-1.6h1.7l-4.8-6.9,1.2-.2a5.3,5.3,0,0,0,3-1.4,5.4,5.4,0,0,0-.3-6.9,5.4,5.4,0,0,0-4-1.4H175.8v16.8h1.5v-7h10.5Zm-3.6-8.1H177.3v-7.5h11.5c4,0,4.6,2.4,4.6,3.9s-.6,3.6-4.3,3.6m-10.2-1.6h10.2c2.4,0,2.7-1,2.7-2s-.4-2.3-3-2.3h-9.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    x: 204.5,
    y: 192.7,
    width: 3,
    height: 18.38
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M208.4,211.8h-4.7V191.9h4.7Zm-3.1-1.6h1.5V193.4h-1.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M234.2,197a17.9,17.9,0,0,0-8.3-2.1,11.6,11.6,0,0,0-4.3.6c-1,.5-1.6,1.1-1.6,1.9s.6,1.4,1.7,1.8a19.2,19.2,0,0,0,3.7.5l5,.4a11.2,11.2,0,0,1,5.1,1.7,4.3,4.3,0,0,1,1.7,3.5,5.2,5.2,0,0,1-2.6,4.6,15.2,15.2,0,0,1-7.5,1.6c-4.6,0-8.3-1.1-10.9-3.1l1.7-2.2a17.9,17.9,0,0,0,9.3,2.6,11.5,11.5,0,0,0,5-.9,2.7,2.7,0,0,0,1.7-2.3c0-1.2-.8-2-2.3-2.4a44.9,44.9,0,0,0-6.3-.6,18.2,18.2,0,0,1-6.3-1.2,3.6,3.6,0,0,1-2.2-3.6,4.5,4.5,0,0,1,2.5-4.1,12.9,12.9,0,0,1,6.8-1.5,17.6,17.6,0,0,1,10,2.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M227.1,212.3c-4.8,0-8.7-1.1-11.4-3.3l-.6-.5,2.6-3.4.6.4a16.4,16.4,0,0,0,8.9,2.5,11.2,11.2,0,0,0,4.6-.8c1.1-.6,1.3-1.2,1.3-1.6s-.2-1.2-1.7-1.6a38,38,0,0,0-6.1-.6,19.9,19.9,0,0,1-6.7-1.3,4.6,4.6,0,0,1-2.6-4.3,5.6,5.6,0,0,1,2.8-4.8,13.9,13.9,0,0,1,7.3-1.6,18.2,18.2,0,0,1,10.4,2.9l.8.5-2.9,3.1-.5-.2a18.2,18.2,0,0,0-8-2,10.2,10.2,0,0,0-4,.6c-1,.4-1,.9-1,1.1s0,.6,1,1a12.2,12.2,0,0,0,3.5.5l5.1.4a12.5,12.5,0,0,1,5.5,1.9,5,5,0,0,1,2,4.2,5.6,5.6,0,0,1-3,5.1c-1.9,1.2-4.5,1.8-7.9,1.8m-9.8-4.1c2.4,1.7,5.7,2.5,9.8,2.5s5.5-.5,7.1-1.5a4.2,4.2,0,0,0,2.2-3.8,3.3,3.3,0,0,0-1.4-2.9c-.9-.8-2.5-1.3-4.7-1.6l-5-.4a15.2,15.2,0,0,1-3.9-.6c-1.8-.6-2.1-1.7-2.1-2.5a2.7,2.7,0,0,1,2-2.6,11.1,11.1,0,0,1,4.6-.7A18.1,18.1,0,0,1,234,196l.8-.9a17,17,0,0,0-8.7-2.1,12.2,12.2,0,0,0-6.4,1.4,3.7,3.7,0,0,0-2.1,3.4,3,3,0,0,0,1.7,2.9,20.1,20.1,0,0,0,6.1,1.1,54.3,54.3,0,0,1,6.4.6c2.4.7,2.9,2.1,2.9,3.2s-.4,2.1-2.2,3a11.4,11.4,0,0,1-5.3,1,18.2,18.2,0,0,1-9.1-2.4Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    points: "265.1 211 245.8 211 245.8 192.7 264.3 192.7 264.3 195.4 248.8 195.4 248.8 200.1 259.6 200.1 259.6 202.9 248.8 202.9 248.8 208.3 265.1 208.3 265.1 211"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ff6c379d-1efd-46ac-94bb-462e4be529ad",
    d: "M265.8,211.8H245V191.9h20.1v4.3H249.6v3.1h10.8v4.3H249.6v3.9h16.2Zm-19.2-1.6h17.7v-1.1H248.1v-7h10.7v-1.2H248.1v-6.3h15.4v-1.2H246.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeLogoSvg);
export default __webpack_public_path__ + "static/media/DE Logo - SVG.de1b808e5342bdde2f101d68d7061dbf.svg";
export { ForwardRef as ReactComponent };